import axios, { type AxiosInstance, type AxiosRequestConfig } from "axios";
import CONFIG from "../../model/TSConfig";
import { HEADER_TOKEN } from "../constants";
import { getMasterTokenFromStorage } from "./localStorage";

const apiUrl = CONFIG.backendURL;

const config: AxiosRequestConfig = { baseURL: apiUrl, timeout: 90000 };
export const AxiosForLegacyBackend: AxiosInstance = axios.create(config);

AxiosForLegacyBackend.interceptors.request.use((config) => {
  switch (config.url) {
    case "account/me":
    case "account/sendMagicLink":
      return config;
    default:
      break;
  }

  const token = getMasterTokenFromStorage();

  if (token) {
    config.headers = { [HEADER_TOKEN]: token };
  }

  return config;
});
